import Vue from 'vue';
import {Mixins} from 'vue-property-decorator';
import Component from 'vue-class-component';

import KEYS from '@/values/keys';
import {_CALLS_STORE, CALLS_EVENTS, SOURCE_END_CALL} from '@/components/calls/values/calls.values';
import {MEETINGS_VARIABLES} from '@/core/values/core.values';

import {CallsService} from '@/components/calls/services/calls.service';

import log from 'js-logger';
import {CallsSocketMixin} from '@/components/calls/services/sip/calls.socket.mixin';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { USER_TYPE } from '@/auth/values/auth.values';
import { MEETINGS_STORE } from '@/meetings/store/meetings.store';

@Component({})
export class EdCallsComponent extends Mixins(CallsSocketMixin) {

  //-- -----------------------------------------------------------------------------------------------------------------
  //-- Attributes & gets
  public devAudio: string = '';
  public devAudioOutput: string = '';

  //-- -----------------------------------------------------------------------------------------------------------------
  //-- Hooks
  mounted() {
    this.$edEventBus.$on(CALLS_EVENTS.CLICK_CALL_START, this.callStart);
    this.$edEventBus.$on(CALLS_EVENTS.CALL_STARTED, this.callStarted);
    this.$edEventBus.$on(CALLS_EVENTS.PARTICIPANT_CHANGED, this.participantChanged);

    //-- Close Meeting from Teacher HangUp
    this.$edEventBus.$on('listenEndCall', this.listenEndIncomingCall);

    //-- Start a call event from teacher client
    this.$edEventBus.$on('listenIncomingCall', this.listenTeacherStartCall);

    if (this.isOnCall()){
      this.devAudio = this.spGetDeviceId('audio');
      this.devAudioOutput = this.spGetDeviceId('audiooutput');
    }
  }

  unmounted() {
    this.$edEventBus.$off(CALLS_EVENTS.CLICK_CALL_START);
    this.$edEventBus.$off(CALLS_EVENTS.CALL_STARTED);
    this.$edEventBus.$off(CALLS_EVENTS.PARTICIPANT_CHANGED);
    this.$edEventBus.$off(CALLS_EVENTS.SHOW_SPLASH);
    this.$edEventBus.$off(CALLS_EVENTS.HIDE_SPLASH);
  }

  /**
   * Changed
   * @param participantId
   */
  participantChanged(participantId){
    this.$forceUpdate();
  }

  //-- -----------------------------------------------------------------------------------------------------------------
  //-- Attributes
  get micIcon(): string {
    if (this.meet && this.classMembers && this.currentMember.muted && this.currentMember.muted){
      return 'microphone-slash';
    } else {
      return 'microphone';
    }
  }

  //-- -----------------------------------------------------------------------------------------------------------------
  //-- Functions

  /**
   * Start Call
   */
  async callStart(params, meetingId) {
    if (!this.isSupportCalls()) {
      this.showModal(this.$i18n.t('errors.errorCallNotSupported') + this.navigatorInfo(), KEYS.EVENT_TYPES.DANGER);
      return;
    }
    this.spShowProcessing();
    let _this = this;
    CallsService.joinCall(meetingId)
        .then(async (res:any) => {
          let conf : any = {
            wssServer: `wss://${res.asteriskUrlDomain}:8089/ws`,
            username: this.$store.state.AuthStore.user.fullName,
            userId: this.$store.state.AuthStore.user.id,
            meetingId: meetingId,
            classId: params.classId,
            className: params.className,
            teacher: this.isTeacher,
            extensionId: res.asteriskConferenceExtension,
            sipDomain: res.asteriskUrlDomain,
            sipUsername: `${res.asteriskUserExtension}`,
            sipPassword: res.asteriskPassword,
            startCall: res.startCall,
            startCallUserTz: res.startCallUserTz ? res.startCallUserTz : res.startCall,
            intervalStartCall: res.intervalStartCall
          };
          let currentCall :any = await _this.currentCall(meetingId);
          let newCall = false;
          if (currentCall.exists) {
            let current = currentCall.members.find(p => p.id === _this.currentUserId);
            if (current.kickouted){
              _this.showModal(_this.$i18n.t('common.wasKickouted'), KEYS.EVENT_TYPES.WARNING);
              return
            }
          } else {
            newCall = true
            await CallsService.createCall({meetingId:meetingId, classId:params.classId});
          }
          await _this.spStartCall(conf, currentCall);

          if(!this.isTeacher){
            if(newCall){
              this.showNoTeacher()
            } else {
              let callUsers = await CallsService.getCallUsers({ meetingId: this.call.meetingId, classId: this.call.classId,})
              let teacherInCall = callUsers.members.find(member => member.type !== USER_TYPE.STUDENT && member.channelId);
              if (!teacherInCall)  this.showNoTeacher();
            }
          }
          log.info('LEGO [callStart] classId: ', params.classId, ' meetingId: ', meetingId, conf);
      }).catch(err => {
        if(err && err.status && err.status == 400){
            if (err.data.message == MEETINGS_VARIABLES.MEETING_NOT_STARTED){
              _this.showModal(_this.$i18n.t('errors.warningTeacherNotInCall'), KEYS.EVENT_TYPES.WARNING);
            }else if (err.data.message == MEETINGS_VARIABLES.MEETING_CONF_EXTENSION_NOT_AVAILABLE){
              _this.showModal(_this.$i18n.t('errors.errorNoExtensionOnCall'), KEYS.EVENT_TYPES.DANGER);
            } else if(err.data.message.includes(this.SIP_ERROR)){
              _this.handleCallError(err);
            } else {
              _this.showModal();
            }
        } else {
          log.error('LEGO [getSpecificMeetingService]:', err)
          _this.showModal();
        }
      }).finally(()=>{
        this.spHideProcessing();
      });
  }

  showNoTeacher(){
    this.$EdToast.create({
      msg:  `${this.$t('common.callWitoutTeacher')}`,
      type: TOAST_TYPES.WARNING,
      top: '3rem',
      timeout: 10000
    });
  }

  spUpdateCache(current){
    return new Promise((resolve) => {
      resolve('');
    });
  }

  /**
   * Event from SipServer (Invitation Accepted or Not)
   */
  callStarted(data){
    log.info('LEGO callStarted -> set IsOnCall ', data);
    if (data.status){
      this.devAudio= this.spGetDeviceId('audio');
      this.devAudioOutput = this.spGetDeviceId('audiooutput');
      this.$store.commit(_CALLS_STORE.MUTATIONS.ON_CALL, {isOnCall: true});
    }else{
      this.spCleanLocalCall()
          .then(()=>this.showModal(
              this.$i18n.t('errors.errorConnCallServer', {reason: data['reason']}), KEYS.EVENT_TYPES.WARNING));
    }
  }

  /**
   * The meeting is active or the user in session is a teacher ?
   * @param meetingId
   * @deprecated - Allow students to join the call even if the teacher is not in the call
   */
  public async validateCall(meetingId: number) {
    if(this.isTeacher) {
      return true;
    }else{
      try {
        let callData = await CallsService.getCallById(meetingId)
        // @ts-ignore
        return callData && callData.status === 'ACTIVE';
      } catch (error) {
        this.showModal(this.$i18n.t('errors.warningTeacherNotInCall'), KEYS.EVENT_TYPES.WARNING);
        return false;
      }
    }
  }

  //-- Signal sent from the teacher to hang up
  listenEndIncomingCall(value: any) {
    if(this.isOnCall && (this.$store.state.CallsStore.callConf.meetingId == value.content)) {
      this.$EdToast.create({
        msg:  `${this.$t('common.callEndedByTeacher', { fullName: value.username})}`,
        type: TOAST_TYPES.WARNING,
        top: '3rem',
        timeout: 5000
      });
    } 

    //-- remove signal that the call is in progress (point)
    //this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_CURRENT_CALLS, {meetingId: value.content, command: 'del'});
  }

  //-- Signal teacher start a call
  listenTeacherStartCall(value: any) {
      //this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_CURRENT_CALLS, {meetingId: value.content, command: 'add'});
    if (this.isOnCall() && value.content == this.meet.meetingId){
      setTimeout(() => {
      this.getAsteriskUserInfo(this.call.classId)
        .then(() => this.$store.dispatch(MEETINGS_STORE.ACTIONS.FETCH_LIVE_MEETINGS))
        .then(() => this.$edEventBus.$emit(CALLS_EVENTS.PARTICIPANT_CHANGED, this.currentUserId));
      }, 2000);
    }
  }

  get btnMicEnable(){
    return !this.isAvailable('audio') ? 'disabled' : '';
  }

  get closeMenu(){
    return true;
  }

  devices(type){
    return this.spGetDevices(type);
  }

  getIconDeviceAudioOutput(devId){
    this.devAudioOutput = this.$store.state.CallsStore.audioOutputId;
    if (devId==this.devAudioOutput || this.devices('audiooutput').length == 1){
      return 'mdi-check-circle-outline';
    }else{
      return 'mdi-checkbox-blank-circle-outline';
    }

  }

  public changeDevice(devType:string ,newDevice: any) {
    if (devType === 'audio'){                          //-- Microphone !!!
      log.info('LEGO changeDevice: type',devType, ' New Id:', newDevice.deviceId, 'Old Id:', this.spAudioSrc().deviceId,' Equal: ', (this.spAudioSrc().deviceId === newDevice.deviceId));
      if (this.spAudioSrc().deviceId === newDevice.deviceId){
        return;
      }
      this.devAudio =  newDevice.deviceId;
      this.spChangeLocalAudioInputDevice(newDevice);
    }else  if (devType === 'audiooutput'){              //-- Speaker !!!
      log.info('LEGO changeDevice: type', devType, ' New Id:', newDevice.deviceId, 'Old Id:', this.spAudioOutput().deviceId,' Equal: ', (this.spAudioOutput().deviceId === newDevice.deviceId));
      if (this.spAudioOutput().deviceId === newDevice.deviceId){
        return;
      }
      this.devAudioOutput =  newDevice.deviceId;
      this.spChangeLocalAudioOutputDevice(newDevice);
    }
    this.$forceUpdate();
    this.$EdContextMenu.close();
  }

  endCallClick(){
    this.endCall(SOURCE_END_CALL.BUTTON_HANGUP)
  }

  async handleLogout(){
    await this.endCall(SOURCE_END_CALL.USER_LOGOUT)
  }


  get processing() {
    return this.$store.state.CallsStore.processing;
  }
}
export default Vue.component('ed-calls', EdCallsComponent);
